import { render } from "./AddAlaUne.vue?vue&type=template&id=2dcd19aa&ts=true"
import script from "./AddAlaUne.vue?vue&type=script&lang=ts"
export * from "./AddAlaUne.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__